import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'jotai'

import 'lib/aws-config'
import App from 'App'

import 'styles/index.scss'
import LoadingScreen from 'components/layout/LoadingScreen'

import { MainContextProvider } from 'ctx/MainContext'
import { AuthContextProvider } from 'ctx/AuthContext'
import { UIContextProvider } from 'ctx/UIContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider>
      <BrowserRouter>
        <Suspense fallback={<LoadingScreen isLoading />}>
          <UIContextProvider>
            <AuthContextProvider>
              <MainContextProvider>
                <App />
              </MainContextProvider>
            </AuthContextProvider>
          </UIContextProvider>
        </Suspense>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)
